import React, { useEffect, useRef } from 'react';
import { Switch, useHistory } from 'react-router-dom';
import { PageLoader } from '../shared/PageLoader';
import { LoaderWrapper } from './elements';
import { useAuthContext } from '../../hooks/useAuthContext';
import { LoginModalProvider } from 'features/shared/Login/LoginModalContext';
import makeRoutes from 'utils/make-routes';
import { accountRoutes } from './routes';

import useGratitudeCheck from 'hooks/useGratitudeCheck';
import useScrollAnchor from 'hooks/useScrollAnchor';

const MAIN_PAGE_PATH = '/main';

const App = () => {
  const { userData, pending, loaded, authorized, fetchUserData, fetchFeatures } = useAuthContext();
  const gratitudeCheck = useGratitudeCheck();
  const history = useHistory();
  const wasAuthorizedRef = useRef(false);
  useScrollAnchor();

  useEffect(() => {
    fetchUserData();
  }, []);

  useEffect(() => {
    if (userData) {
      gratitudeCheck.fetch();
      fetchFeatures();
    }
  }, [userData]);

  useEffect(() => {
    if (!loaded) {
      return;
    }

    if (authorized) {
      wasAuthorizedRef.current = true;
      return;
    }

    if (!wasAuthorizedRef.current) {
      return;
    }

    history.replace(MAIN_PAGE_PATH);
  }, [authorized, loaded, history]);

  if (pending || !loaded || (userData && !gratitudeCheck.loaded)) {
    return (
      <LoaderWrapper data-testid="app-loader">
        <PageLoader />
      </LoaderWrapper>
    );
  }

  return (
    <LoginModalProvider>
        <Switch>{makeRoutes(accountRoutes)}</Switch>
    </LoginModalProvider>
  );
};

export default App;
